import { GetServerSideProps, GetStaticPropsContext } from 'next';

import MainDocument from 'presentations/views/components/MainDocument';
import FeaturePage from 'presentations/views/components/pages/FeaturePage';
import {
  apiPath,
  featurePath,
  productIntegrationsPath,
  webPath,
} from 'presentations/routes/path';
import { get } from 'infras/rest_client';
import { FeatureItem } from 'presentations/api/schema/contents';
import { getFrequentlyAskedQuestions } from 'presentations/views/components/atoms/StructuredData';

interface ServerProps {
  feature: FeatureItem;
  linkCanonical: string;
}

// export async function getStaticPaths({ locales }: { locales: string[] }) {
//   const paths: Object[] = [];
//   const result = await get(
//     apiPath(`/v1/contents/features`, {
//       page: 1,
//       perPage: 200,
//     }),
//   );
//   if (!result.isSuccess) {
//     throw result.errorMessage;
//   }
//   if (!result.data) {
//     return 'no result data';
//   }
//   const features: FeatureListItem[] = result.data;
//   for (const feature of features) {
//     for (const locale of locales) {
//       paths.push({
//         params: {
//           featureId: feature.slug,
//         },
//         locale,
//       });
//     }
//   }
//   return {
//     paths,
//     fallback: false,
//   };
// }

export const getServerSideProps: GetServerSideProps = async ({
  locale,
  params,
}: any) => {
  // export async function getStaticProps({
  //   locale,
  //   params,
  // }: GetStaticPropsContext) {
  if (!params) return { notFound: true };
  const featureId = String(params.featureId);

  // Search Consoleでインデックスのリダイレクトが確認されたら削除してOK
  if (featureId === 'integrations') {
    return {
      redirect: {
        permanent: false,
        destination: productIntegrationsPath(),
      },
    };
  }

  const result = await get(
    apiPath(`/v1/contents/features/${featureId}`, {
      locale,
    }),
  );
  if (!result.isSuccess) {
    return { notFound: true };
  }
  if (!result.data) {
    return { notFound: true };
  }

  const feature: FeatureItem = result.data;
  if (feature.redirectUrl) {
    return {
      redirect: {
        permanent: false,
        destination: feature.redirectUrl,
      },
    };
  }

  const props: ServerProps = {
    feature,
    linkCanonical: webPath(featurePath(featureId), locale),
  };
  return {
    props,
    // revalidate: 60 * 120
  };
};

export default function Page(props: ServerProps) {
  const faqs = props.feature.answers.map((a) => ({
    question: a.question,
    answer: a.description,
  }));

  return (
    <MainDocument
      title={props.feature.name}
      image={props.feature.thumbnailUrl}
      description={props.feature.summary}
      linkCanonical={props.linkCanonical}
      isShowDownloadLink
      structuredData={
        faqs.length > 0 && (
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: getFrequentlyAskedQuestions({ items: faqs }),
            }}
          />
        )
      }
    >
      <FeaturePage feature={props.feature} />
    </MainDocument>
  );
}
